import { HTMLAttributes } from "react";
import { useState } from "react";
import styled from "styled-components";
import { Accordion } from "@teamscheme/accordion";
import { EVENTS } from "../Tracking";
import FaqAccordion from "./FaqAccordion";
import { FAQ_SECTIONS } from "./FaqQuestions";

const TopFaq = styled(function TopFaq(
  props: Omit<HTMLAttributes<HTMLDivElement>, "children">
) {
  const items = FAQ_SECTIONS.map(({ items }) =>
    items.filter((i) => i.top)
  ).flat();

  const [openedId, setOpenedId] = useState(null);

  return (
    <FaqAccordion {...props}>
      <section>
        {items.map((item, index) => (
          <Accordion.Row
            id={index}
            title={item.question}
            key={index}
            open={openedId === index}
            openEvent={{
              ...EVENTS.LANDING_PAGE.OPEN_QUESTION,
              label: item.question,
            }}
            onOpen={() => {
              if (openedId !== index) {
                setOpenedId(null);
              }
            }}
          >
            <p>{item.answer}</p>
          </Accordion.Row>
        ))}
      </section>
    </FaqAccordion>
  );
})``;

export default TopFaq;
